import { Box, Paper, Skeleton, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { candidateColumns, sectionCardSx, sectionHeaderSx, tableBodyCellSx, tableHeadCellSx } from './shared';

export default function BottomingFlowSkeleton() {
  return (
    <Stack spacing={1.5}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 1.5 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <Skeleton variant="rounded" width={42} height={42} sx={{ borderRadius: 1.5 }} />
          <Box>
            <Skeleton width={240} height={24} />
            <Skeleton width={360} height={14} />
          </Box>
        </Box>
        <Skeleton variant="rounded" width={92} height={32} sx={{ borderRadius: 1 }} />
      </Box>

      <Paper elevation={0} sx={{ ...sectionCardSx }}>
        <Box sx={{ px: 1.5, pt: 1, pb: 0.65, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.8 }}>
            <Skeleton variant="circular" width={16} height={16} />
            <Skeleton width={130} height={18} />
            <Skeleton width={260} height={13} />
          </Box>
          <Skeleton variant="rounded" width={260} height={24} sx={{ borderRadius: 1 }} />
        </Box>
        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', lg: 'repeat(5, 1fr)' }, gap: 0.8, p: 1 }}>
          {[0, 1, 2, 3, 4].map((item) => (
            <Box key={item} sx={{ display: 'flex', gap: 0.85, px: 1, py: 0.75, bgcolor: '#f8fafc', borderRadius: 1 }}>
              <Skeleton variant="rounded" width={3} height={36} />
              <Box sx={{ flex: 1 }}>
                <Skeleton width="52%" height={10} />
                <Skeleton width="78%" height={22} />
              </Box>
            </Box>
          ))}
        </Box>
      </Paper>

      <Stack direction={{ xs: 'column', xl: 'row' }} spacing={1.4}>
        <Paper elevation={0} sx={{ ...sectionCardSx, flex: 1.3 }}>
          <Box sx={sectionHeaderSx}>
            <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={1.5}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Skeleton variant="rounded" width={28} height={28} sx={{ borderRadius: 1 }} />
                <Box>
                  <Skeleton width={180} height={16} />
                  <Skeleton width={230} height={14} />
                </Box>
              </Box>
              <Skeleton variant="rounded" width={460} height={30} sx={{ borderRadius: 1 }} />
            </Stack>
          </Box>
          <TableContainer sx={{ bgcolor: '#fff', overflow: 'hidden' }}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  {candidateColumns.map((column) => (
                    <TableCell key={column.labelKey} sx={{ ...tableHeadCellSx, ...column.sx }}>
                      <Skeleton width="70%" height={12} />
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {Array.from({ length: 8 }).map((_, rowIndex) => (
                  <TableRow key={rowIndex} sx={{ bgcolor: rowIndex % 2 === 0 ? '#fff' : '#fafbfc' }}>
                    {candidateColumns.map((column, cellIndex) => (
                      <TableCell key={column.labelKey} sx={{ ...tableBodyCellSx, ...column.sx }}>
                        {cellIndex === 0 ? (
                          <Box>
                            <Skeleton width={42} height={16} />
                            <Skeleton width={140} height={12} />
                          </Box>
                        ) : cellIndex === 2 ? (
                          <Skeleton variant="rounded" width={64} height={22} sx={{ borderRadius: 1 }} />
                        ) : (
                          <Skeleton width={cellIndex > 7 ? 60 : 74} height={16} sx={{ ml: column.sx?.textAlign === 'right' ? 'auto' : undefined, mx: column.sx?.textAlign === 'center' ? 'auto' : undefined }} />
                        )}
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>

        <Stack spacing={2} sx={{ flex: 0.9 }}>
          {[0, 1].map((card) => (
            <Paper key={card} elevation={0} sx={{ ...sectionCardSx }}>
              <Box sx={sectionHeaderSx}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Skeleton variant="rounded" width={28} height={28} sx={{ borderRadius: 1 }} />
                  <Skeleton width={150} height={16} />
                </Box>
              </Box>
              <Box sx={{ p: 1.2 }}>
                {Array.from({ length: card === 0 ? 6 : 4 }).map((_, index) => (
                  <Box key={index} sx={{ display: 'grid', gridTemplateColumns: '1.8fr repeat(4, 1fr)', gap: 1, py: 0.8 }}>
                    {[0, 1, 2, 3, 4].map((cell) => <Skeleton key={cell} height={12} />)}
                  </Box>
                ))}
              </Box>
            </Paper>
          ))}
          <Paper elevation={0} sx={{ ...sectionCardSx, p: 2.1 }}>
            <Skeleton width={150} height={18} />
            <Skeleton width="100%" height={14} sx={{ mt: 1 }} />
            <Skeleton width="86%" height={14} />
            <Skeleton width="72%" height={14} />
          </Paper>
        </Stack>
      </Stack>
    </Stack>
  );
}
